import { gql } from "@apollo/client";

export default gql`
  query ListTagsBySlugs($slugs: [String!]!) {
    listTagsBySlugs(slugs: $slugs) {
      name
      slug
    }
  }
`;
